// ======================= CONFIG =======================
const CONFIG = {
    fourOzSkus: ["TTFC-4OZ", "UFC-4OZ", "CAR-4OZ", "UFC-EOF-4OZ"], // Add specific SKUs if needed, e.g. ["PORR-4OZ-CHERRY", "PORR-4OZ-MINT"]
    debug: true, // Set to false to disable debug logs
    giftImageUrl:
      "/cdn/shop/files/0e015eefd62879b5b924afe07594322cc68e0f72_1_200x.png?v=1759607793",
      GIFT_VARIANT_ID: "46940001599706"
  };
  
  // ======================= HELPER FUNCTIONS =======================
  
  function log(...args) {
    if (CONFIG.debug) {
      console.log("[BTGO Checkout]", ...args);
    }
  }
  
  // Get gift variant ID from various sources
  function getGiftVariantId() {
    // Try window global first
    if (CONFIG.GIFT_VARIANT_ID) {
      return Number(CONFIG.GIFT_VARIANT_ID);
    }
  
    // Try data attribute
    const hostEl = document.querySelector("[data-gift-variant-id]");
    if (hostEl?.dataset?.giftVariantId) {
      return Number(hostEl.dataset.giftVariantId);
    }
  
    // Try gift progress title
    const progressEl = document.querySelector(".pGiftProgressTitle");
    if (progressEl?.dataset?.id) {
      return Number(progressEl.dataset.id);
    }
  
    return 0;
  }
  
  // Check if we're on checkout page
  function isCheckoutPage() {
    const path = location.pathname || "";
    return path.indexOf("/checkout") === 0 || path.indexOf("/checkouts/") > -1;
  }
  
  // Fetch cart
  async function getCart() {
    try {
      const response = await fetch("/cart.js", {
        cache: "no-store",
        credentials: "same-origin",
      });
      if (!response.ok) throw new Error(`/cart.js ${response.status}`);
      return await response.json();
    } catch (error) {
      log("Error fetching cart:", error);
      throw error;
    }
  }
  
  // API helper for POST requests
  async function apiPost(url, payload) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
  
      const data = await response.json().catch(() => null);
  
      if (!response.ok) {
        const msg = data?.description || data?.message || response.statusText;
        log("Cart API error:", url, response.status, msg);
        throw new Error(msg || `HTTP ${response.status}`);
      }
  
      return data;
    } catch (error) {
      log("API error:", url, error);
      throw error;
    }
  }
  
  // Check if item is the gift line
  function isGiftLine(item) {
    if (!item) return false;
  
    const giftId = getGiftVariantId();
  
    // If gift ID matches, consider it a gift regardless of properties
    if (giftId && item.variant_id === giftId) {
      return true;
    }
  
    // Also check properties for gift markers
    const props = item.properties || {};
    const msg = String(props.Message || "")
      .toLowerCase()
      .trim();
    const legacy = String(props.Gift || "")
      .toLowerCase()
      .trim();
  
    return msg === "gift" || legacy === "true" || legacy === "gift";
  }
  
  // Count 4oz items in cart
  function countFourOunceItems(cart) {
    let count = 0;
  
    (cart.items || []).forEach((item) => {
      // Skip the gift item itself
      if (isGiftLine(item)) {
        log(`Skipping gift item: ${item.product_title}`);
        return;
      }
  
      const productTitle = String(item.product_title || "")
        .toLowerCase()
        .trim();
      const variantTitle = String(item.variant_title || "")
        .toLowerCase()
        .trim();
      const combinedTitle = `${productTitle} ${variantTitle}`;
  
      // PRIORITY 1: Check specific SKUs first (most reliable method)
      // SKUs: TTFC-4OZ (Purple), UFC-4OZ (Pink), CAR-4OZ (Yellow), UFC-EOF-4OZ (Green)
      if (CONFIG.fourOzSkus.length > 0 && item.sku) {
        const itemSku = String(item.sku).trim().toUpperCase();
        const matchesSku = CONFIG.fourOzSkus.some(
          (sku) => String(sku).trim().toUpperCase() === itemSku
        );
        if (matchesSku) {
          count += item.quantity;
          log(`✓ Matched 4oz SKU: ${item.sku} (${item.product_title} - ${item.variant_title}), quantity: ${item.quantity}`);
          return;
        }
      }
  
      // PRIORITY 2: Special case - Flare Care Duo counts as 2 items (contains two 4oz products)
      if (productTitle.includes("flare care duo")) {
        count += item.quantity * 2;
        log(
          `✓ Matched Flare Care Duo: ${item.product_title}, counting as ${
            item.quantity * 2
          } (2x 4oz products)`
        );
        return; // Return early to avoid double-counting
      }
  
      // PRIORITY 3: Fallback - Check variant title for 4oz patterns
      // Multiple regex patterns to catch variations:
      // - "4 oz", "4oz", "4 ounce", "4-oz", "4 - oz", etc.
      const isFourOz = /\b4\s*oz\b|\b4\s*ounce\b|\b4[-\s]oz\b/.test(
        combinedTitle
      );
  
      if (isFourOz) {
        count += item.quantity;
        log(
          `✓ Matched 4oz pattern: ${item.product_title} - ${item.variant_title}, quantity: ${item.quantity}`
        );
      }
    });
  
    log(`====== Total 4oz items counted: ${count} ======`);
    return count;
  }
  
  // ======================= GIFT MANAGEMENT =======================
  
  // Remove all gift items from cart
  async function removeAllGifts(cart) {
    const giftId = getGiftVariantId();
    if (!giftId) return cart;
  
    const giftLines = (cart.items || []).filter(
      (item) => item.variant_id === giftId
    );
  
    if (giftLines.length === 0) {
      log("No gift items to remove");
      return cart;
    }
  
    log(`Removing ${giftLines.length} gift item(s)`);
    await Promise.all(
      giftLines.map((line) =>
        apiPost("/cart/change.js", { id: line.key, quantity: 0 })
      )
    );
  
    return await getCart();
  }
  
  // Add gift item to cart
  async function addGift() {
    const giftId = getGiftVariantId();
    if (!giftId) {
      log("ERROR: Gift variant ID not found");
      return;
    }
  
    log("Adding gift item to cart");
    await apiPost("/cart/add.js", {
      items: [{ id: giftId, quantity: 1, properties: { Message: "Gift" } }],
    });
  }
  
  // Ensure exactly one gift in cart
  async function ensureOneGift(cart) {
    const giftId = getGiftVariantId();
    if (!giftId) return cart;
  
    const giftLines = (cart.items || []).filter(
      (item) => item.variant_id === giftId
    );
    const flaggedGift = giftLines.find(isGiftLine);
  
    // If we have exactly one properly flagged gift with quantity 1, we're done
    if (giftLines.length === 1 && flaggedGift && flaggedGift.quantity === 1) {
      log("Gift already correctly in cart");
      return cart;
    }
  
    // Remove all gifts and add one fresh
    await removeAllGifts(cart);
    await addGift();
  
    return await getCart();
  }
  
  // ======================= MAIN PROMOTION LOGIC =======================
  
  let processing = false;
  
  async function finalizePromotion() {
    if (processing) {
      log("Already processing, skipping");
      return;
    }
  
    processing = true;
  
    try {
      const giftId = getGiftVariantId();
      if (!giftId) {
        log("ERROR: Gift variant ID not configured");
        return;
      }
  
      let cart = await getCart();
      const fourOzCount = countFourOunceItems(cart);
      const qualified = fourOzCount >= 2;
  
      log(
        `Qualification check: ${fourOzCount} 4oz items, qualified: ${qualified}`
      );
  
      if (!qualified) {
        // Not qualified: remove gift
        cart = await removeAllGifts(cart);
        log("Gift removed (not qualified)");
      } else {
        // Qualified: ensure gift is present
        cart = await ensureOneGift(cart);
        log("Gift added (qualified)");
  
        // Final verification
        const finalCart = await getCart();
        const hasGift = finalCart.items.some(isGiftLine);
  
        if (!hasGift) {
          log(
            "ERROR: Final verification failed - gift missing after finalization"
          );
          throw new Error("Gift missing after finalization");
        }
      }
  
      // Small delay to ensure cart is settled
      await new Promise((resolve) => setTimeout(resolve, 150));
    } catch (error) {
      log("ERROR in finalizePromotion:", error.message);
      // Redirect to home on critical failure
      window.location.href = "/";
    } finally {
      processing = false;
    }
  }
  
  // ======================= GIFT NUDGE UI =======================
  
  function createGiftNudgeHTML(fourOzCount) {
    const progressPercent = Math.min((fourOzCount / 2) * 100, 100);
    const progressColor =
      fourOzCount >= 2 ? "rgb(71, 174, 0)" : "rgba(145, 145, 145, 1)";
  
    let message = "";
    if (fourOzCount >= 2) {
      message = "<span>FREE GIFT</span> is added to your order 🎁";
    } else if (fourOzCount === 1) {
      message = "One more 4oz to get a <span>FREE GIFT</span> 🎁";
    } else {
      message = "Add two 4oz to get a <span>FREE GIFT</span> 🎁";
    }
  
    return `
      <div class="pGiftCtn inside">
        <div class="pGiftDiv reverse">
          <div class="pGiftInfo">
            <div class="pGiftImageCtn">
              <img src="${
                CONFIG.giftImageUrl
              }" alt="Universal Flare Care Gift" class="pGiftImage" loading="lazy">
            </div>
            <div class="pGiftTitleCtn">
              <p class="pGiftMessage">${message}</p>
              <div class="pGiftProgressCtn">
                <div class="pGiftProgressRail">
                  <div class="pGiftProgress" style="transform: scaleX(${
                    progressPercent / 100
                  }); background: ${progressColor};"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  
  async function updateGiftNudge() {
    const container = document.querySelector(".giftNudgeCartCtn");
    if (!container) {
      log("Gift nudge container not found");
      return;
    }
  
    const cart = await getCart();
    const fourOzCount = countFourOunceItems(cart);
  
    container.innerHTML = createGiftNudgeHTML(fourOzCount);
    log(`Gift nudge updated: ${fourOzCount} 4oz items`);
  }
  
  // ======================= CART DRAWER INTEGRATION =======================
  
  function getCartDrawer() {
    window.theme = window.theme || {};
    if (!window.theme.cartDrawer && window.theme.CartDrawer) {
      window.theme.cartDrawer = new window.theme.CartDrawer();
    }
    return window.theme.cartDrawer;
  }
  
  function rebuildCartDrawer() {
    try {
      const drawer = getCartDrawer();
      if (drawer?.cartForm?.buildCart) {
        drawer.cartForm.buildCart();
      }
    } catch (error) {
      log("Error rebuilding cart drawer:", error);
    }
  }
  
  // ======================= CHECKOUT INTERCEPTION =======================
  
  function disableCheckoutButtons(form, disabled) {
    const buttons = form.querySelectorAll(
      '[name="checkout"], .cart__checkout, a[href="/checkout"], .shopify-payment-button__button'
    );
  
    buttons.forEach((button) => {
      if (disabled) {
        button.setAttribute("disabled", "disabled");
        button.style.pointerEvents = "none";
        button.style.opacity = "0.6";
      } else {
        button.removeAttribute("disabled");
        button.style.pointerEvents = "";
        button.style.opacity = "";
      }
    });
  }
  
  function attachCheckoutIntercept() {
    const form = document.getElementById("CartDrawerForm");
    if (!form) {
      log("CartDrawerForm not found");
      return;
    }
  
    log("Attaching checkout intercept");
  
    // Prevent double-clicks
    form.addEventListener(
      "click",
      (e) => {
        const button = e.target.closest(
          '[name="checkout"], .cart__checkout, button[type="submit"][name="checkout"], .shopify-payment-button__button'
        );
  
        if (!button) return;
  
        if (button.dataset.locked === "1") {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
  
        button.dataset.locked = "1";
        button.style.pointerEvents = "none";
        button.style.opacity = "0.6";
  
        // Auto-unlock after timeout
        setTimeout(() => {
          delete button.dataset.locked;
          button.style.pointerEvents = "";
          button.style.opacity = "";
        }, 4000);
      },
      true // capture phase
    );
  
    // Intercept checkout submission
    form.addEventListener(
      "submit",
      async (e) => {
        const submitter = e.submitter || document.activeElement;
        const isCheckout =
          submitter &&
          (submitter.name === "checkout" ||
            submitter.getAttribute("data-action") === "checkout" ||
            submitter.value === "Checkout");
  
        if (!isCheckout) return;
  
        e.preventDefault();
        e.stopPropagation();
  
        log("Checkout submission intercepted");
        disableCheckoutButtons(form, true);
  
        try {
          await finalizePromotion();
  
          // Add hidden input for submitter if needed
          if (
            submitter?.name &&
            !form.querySelector(`input[type="hidden"][name="${submitter.name}"]`)
          ) {
            const hidden = document.createElement("input");
            hidden.type = "hidden";
            hidden.name = submitter.name;
            hidden.value = submitter.value || "Checkout";
            form.appendChild(hidden);
          }
  
          // Submit form
          form.submit();
        } catch (error) {
          log("ERROR during checkout:", error);
          window.location.href = "/checkout";
        } finally {
          setTimeout(() => {
            disableCheckoutButtons(form, false);
          }, 800);
        }
      },
      true // capture phase
    );
  }
  
  // ======================= PAGE LOAD HANDLERS =======================
  
  async function clearGiftOnLoad() {
    if (isCheckoutPage()) {
      log("Skipping gift clear on checkout page");
      return;
    }
  
    const giftId = getGiftVariantId();
    if (!giftId) {
      log("No gift variant ID, skipping clear");
      return;
    }
  
    log("Clearing gift on page load");
    let cart = await getCart();
    cart = await removeAllGifts(cart);
  
    rebuildCartDrawer();
  }
  
  async function initGiftNudge() {
    await updateGiftNudge();
    rebuildCartDrawer();
  }
  
  // ======================= EVENT LISTENERS =======================
  
  // Listen for cart updates
  document.addEventListener("cart:updated", async (event) => {
    log("Cart updated event");
    const cart = event.detail?.cart;
  
    if (cart && !isCheckoutPage()) {
      // Remove gift if it exists (it will be added back at checkout if qualified)
      await removeAllGifts(cart);
      await updateGiftNudge();
    }
  });
  
  // Listen for product added
  document.addEventListener("ajaxProduct:added", async () => {
    log("Product added event");
    await clearGiftOnLoad();
    await updateGiftNudge();
  });
  
  // ======================= INITIALIZATION =======================
  
  async function init() {
    if (isCheckoutPage()) {
      log("Checkout page detected, skipping init");
      return;
    }
  
    log("Initializing BTGO checkout");
  
    getCartDrawer(); // Ensure cart drawer exists
    await clearGiftOnLoad();
    await initGiftNudge();
    attachCheckoutIntercept();
  
    log("BTGO checkout initialized");
  }
  
  // Boot on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  